import { ColumnDef } from '@tanstack/react-table';
import { PencilSimple } from '@phosphor-icons/react';
import { DataTableColumnHeader } from '@/components/core';
import { formatDate } from '@/lib/utils/custom-date/custom-date';
import { Button } from '@/components/ui-kit/button';
import { Designation } from '../../types/designation.types';

interface CreateDesignationTableColumnsProps {
  t: (key: string) => string;
  onEdit: (designation: Designation) => void;
  canUpdate?: boolean;
}

export const createDesignationTableColumns = ({
  t,
  onEdit,
  canUpdate = true,
}: CreateDesignationTableColumnsProps): ColumnDef<Designation>[] => [
  {
    id: 'Title',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('DESIGNATION_NAME')} />,
    accessorFn: (row) => row.Title ?? '',
    cell: ({ row }) => <span className="truncate font-medium">{row.original.Title}</span>,
  },
  {
    id: 'Weight',
    meta: { filter: { type: 'number' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('WEIGHT')} />,
    accessorFn: (row) => row.Weight ?? 0,
  },
  {
    id: 'CreatedDate',
    meta: { filter: { type: 'datetime' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('CREATION_DATE')} />,
    accessorFn: (row) => row.CreatedDate ?? '',
    cell: ({ row }) =>
      row.original.CreatedDate ? formatDate(new Date(row.original.CreatedDate), true) : '-',
  },
  {
    id: 'LastUpdatedDate',
    meta: { filter: { type: 'datetime' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('LAST_MODIFIED')} />,
    accessorFn: (row) => row.LastUpdatedDate ?? '',
    cell: ({ row }) =>
      row.original.LastUpdatedDate ? formatDate(new Date(row.original.LastUpdatedDate), true) : '-',
  },
  ...(canUpdate
    ? [
        {
          id: 'actions',
          // Card: top right, as the old portal's card header.
          meta: { mobile: 'badge' as const },
          header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
          enableSorting: false,
          enableHiding: false,
          cell: ({ row }: { row: { original: Designation } }) => (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onEdit(row.original)}
              aria-label={t('EDIT')}
            >
              <PencilSimple className="size-4" />
            </Button>
          ),
        },
      ]
    : []),
];
